import apiSportsObjects from '@/api/sports-objects'
import {isEmpty, isNil, pipe, propOr, reject, unless} from 'ramda'

const state = {
  isLoading: false,
  sportsObjects: [],
  validationErrors: null,
  total: 1,
  lastPage: null,
}

export const mutationTypes = {
  getSportObjectsListStart: '[sportsObjects list] getSportObjectsStart',
  getSportObjectsListSuccess: '[sportsObjects list ] getSportObjectsSuccess',
  getSportObjectsListFailure: '[sportsObjects list ] getSportObjectsFailure',
}

export const actionType = {
  getSportListObjects: '[sportsObjects list] getSportObjects',
}

const mutations = {
  [mutationTypes.getSportObjectsListStart](state) {
    state.isLoading = true
    state.validationErrors = null
  },

  [mutationTypes.getSportObjectsListSuccess](state, payload) {
    if (payload.isAdd) {
      state.sportsObjects = [...state.sportsObjects, ...payload.list]
    } else {
      state.sportsObjects = payload.list
    }
    state.total = payload.total
    state.lastPage = payload.lastPage
    state.isLoading = false
  },

  [mutationTypes.getSportObjectsListFailure](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  },
}

const actions = {
  [actionType.getSportListObjects](context, data) {
    const params = pipe(
      propOr(null, 'params'),
      unless(isNil, reject(isEmpty))
    )(data)

    const isAdd = propOr(false, 'isAdd', data)

    context.commit(mutationTypes.getSportObjectsListStart)
    return new Promise((resolve) => {
      apiSportsObjects
        .getSportObjectsList(params)
        .then((response) => {
          context.commit(mutationTypes.getSportObjectsListSuccess, {
            ...response.data,
            isAdd,
          })
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.getSportObjectsListFailure,
            result.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
